import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "currentColor",
  class: "qi-507"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", { d: "m14.719 7.343-1.167-.976a.81.81 0 0 0-.109-.076.873.873 0 0 0-.423-.115.863.863 0 0 0-.592.245.816.816 0 0 0-.17.255H5.734a2.822 2.822 0 0 1-1.588-2.298c.035-1.085 1.127-1.992 2.717-2.259a3.623 3.623 0 0 1 3.878 1.514.5.5 0 0 0 .826-.563 4.62 4.62 0 0 0-4.87-1.937c-2.072.347-3.5 1.638-3.551 3.212a3.176 3.176 0 0 0 1.017 2.33H2.678a1.333 1.333 0 0 0-1.333 1.333 1.333 1.333 0 0 0 1.333 1.333h7.355c1.138.514 1.818 1.23 1.872 2.033a2.26 2.26 0 0 1-1.695 2.055 5.6 5.6 0 0 1-5.707-.786.5.5 0 1 0-.662.748 6.474 6.474 0 0 0 4.128 1.473 7.212 7.212 0 0 0 2.6-.502 3.219 3.219 0 0 0 2.334-3.055 2.928 2.928 0 0 0-1.047-1.966h.477a.845.845 0 0 0 .7.389.88.88 0 0 0 .425-.116.79.79 0 0 0 .108-.076l1.154-.968a.8.8 0 0 0-.001-1.227zM13.2 8.8l-.148.125h-.004l-.014.005h-.002c-.014 0-.028-.007-.028-.016v-.012l-.398-.36h-1.948l-.001-.001H2.145V7.476h10.449l.4-.405v-.08c0-.009.012-.015.026-.015a.036.036 0 0 1 .018.005l.004.003.001-.002.876.736.286.239.001.001z" }, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3))
}
export default { render: render }